module.exports={render:function (){var _vm=this;
  return _vm._h('main', [_vm._h('div', [_vm._h('v-container', [_vm._h('v-card', {}, [_vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "card-content"
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/svg/communication/user.svg",
      "style": "height: 40px;"
    }
  }), " ", _vm._h('span', {
    staticClass: "card-title",
    attrs: {
      "style": "vertical-align:top;"
    }
  }, ["\n            サークルメンバー\n          "]), " ", _vm._h('table', {
    staticClass: "bordered"
  }, [_vm._h('thead', [_vm._h('tr', [_vm._h('th', {
    attrs: {
      "data-field": "id"
    }
  }, ["名前"]), " ", _vm._h('th', {
    attrs: {
      "data-field": "name"
    }
  }, ["役職"])])]), " ", _vm._h('tbody', [_vm._h('tr', [_vm._h('td', ["宮乃ぺこ"]), " ", _vm._h('td', ["代表"])]), " ", _vm._h('tr', [_vm._h('td', ["明地えしら"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["ecolight"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["うりMk-2"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["ryuto"]), " ", _vm._h('td')]), " ", _vm._h('tr', [_vm._h('td', ["すず"]), " ", _vm._h('td')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40df9a0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Members.vue
// module id = 52
// module chunks = 2